<div class="staff-container">
  <div class="staff">
    <h2 class="staff__title">{{ 'staff.pageHeader' | translate }}</h2>
    <ng-template #staffTable let-rows let-isLoading="isLoading">
      <div class="staff__wrapper">
        <div class="table-container">
          <div class="table-heading">
            <app-inventory-table-search
              [placeholder]="'staff.table.placeholders.search' | translate"
            />
            <div class="staff__buttons">
              <button mat-stroked-button type="button" class="staff__secondary-btn">
                <app-icon class="icon-staff" [icon]="iconName.FILTER" />
                <span>{{ 'staff.table.buttons.filter' | translate }}</span>
              </button>
              <button mat-stroked-button type="button" class="staff__secondary-btn upload-btn">
                <app-icon class="icon-staff" [icon]="iconName.UPLOAD" />
                <span>{{ 'staff.table.buttons.uploadStaff' | translate }}</span>
              </button>
              <button mat-stroked-button type="button" class="staff__secondary-btn">
                <app-icon class="icon-staff" [icon]="iconName.EXPORT" />
                <span>{{ 'staff.table.buttons.export' | translate }}</span>
              </button>
              <button
                mat-button
                type="button"
                color="primary"
                class="staff__add-staff-btn"
                (click)="openCreateStaffDialog()"
              >
                <span>{{ 'staff.table.buttons.addStaff' | translate }}</span>
                <mat-icon class="add-icon">add</mat-icon>
              </button>
            </div>
          </div>
          <div class="table-wrapper">
            <table mat-table [dataSource]="rows" class="full-width-table">
              @for (column of staffTableColumnsConfig(); track column.key) {
                <ng-container [matColumnDef]="column.key">
                  <th [class]="column.headerClass" mat-header-cell *matHeaderCellDef>
                    <div class="header-cell__wrapper">
                      <span>{{ column.label | translate }}</span>
                      @if (column.sortable) {
                        <app-icon class="icon" [icon]="iconName.SORTABLE_ARROW" />
                      }
                    </div>
                  </th>
                  <td [class]="column.cellClass" mat-cell *matCellDef="let staff">
                    @if (isLoading) {
                      @if (column.key === staffColumnKey.Actions) {
                        <div class="skeleton skeleton--icon"></div>
                      } @else {
                        <div class="skeleton skeleton--text"></div>
                      }
                    } @else {
                      @if (column.key === staffColumnKey.StaffFirstName) {
                        {{ staff.firstName }} {{ staff.lastName }}
                      } @else if (column.key === staffColumnKey.Status) {
                        @let config = getStatusConfig(staff.status);
                        <span class="status" [ngClass]="config.class">
                          {{ config.label | translate }}
                        </span>
                      } @else if (column.key === staffColumnKey.Actions) {
                        <button
                          class="cell"
                          mat-icon-button
                          type="button"
                          [matMenuTriggerFor]="actionsMenu"
                          #menuTrigger="matMenuTrigger"
                        >
                          <mat-icon [class.menu-open]="menuTrigger.menuOpen">more_vert</mat-icon>
                        </button>
                        <mat-menu #actionsMenu="matMenu" class="actions-menu">
                          <button mat-menu-item type="button">
                            <app-icon class="icon-customer" [icon]="iconName.VIEW_ORDER" />
                            {{ 'staff.table.actions.viewStaff' | translate }}
                          </button>

                          <button
                            mat-menu-item
                            type="button"
                            (click)="openEditStaffDialog(staff, menuTrigger)"
                          >
                            <app-icon class="icon-customer" [icon]="iconName.PENCIL" />
                            {{ 'staff.table.actions.editStaff' | translate }}
                          </button>
                        </mat-menu>
                      } @else {
                        {{ staff[column.key] }}
                      }
                    }
                  </td>
                </ng-container>
              }
              <tr mat-header-row *matHeaderRowDef="staffTableColumnKeys"></tr>
              <tr mat-row *matRowDef="let row; columns: staffTableColumnKeys"></tr>
            </table>
          </div>
        </div>
        <div class="staff__footer footer">
          @if (showPagination()) {
            <app-table-pagination
              [pagination]="staffPagination()"
              (pageChange)="handlePageChange($event)"
              (pageSizeChange)="handlePageSizeChange($event)"
            />
          }
        </div>
      </div>
    </ng-template>
    @switch (viewState()) {
      @case ('data') {
        <ng-container
          *ngTemplateOutlet="staffTable; context: { $implicit: staff(), isLoading: false }"
        />
      }
      @case ('loading') {
        <ng-container
          *ngTemplateOutlet="staffTable; context: { $implicit: skeletonRows(), isLoading: true }"
        />
      }
      @case ('empty') {
        <div class="empty-staff">
          <h2 class="empty-staff__title">
            {{ 'staff.table.emptyTable.noItemsTitle' | translate }}
          </h2>
          <span class="empty-staff__description">
            {{ 'staff.table.emptyTable.noItemsDescription' | translate }}
          </span>
          <button
            mat-button
            color="primary"
            class="staff__add-staff-btn"
            type="button"
            (click)="openCreateStaffDialog()"
          >
            <span>{{ 'staff.table.emptyTable.addStaff' | translate }}</span>
            <mat-icon class="add-icon">add</mat-icon>
          </button>
        </div>
      }
    }
  </div>
</div>
